export const baseUrl = process.env.REACT_APP_API_URL;
export const LOGIN = "v1/adminLogin";
export const DOWNLOAD_FILE = "public/downloadFileById";
export const getStaticsData = "public/getStaticsData";

/* Advertisement */
export const GET_ALL_ADVERTISMENT = "admin/v2/Advertisement/GetAll";
export const GET_ADVERTISMENT = "admin/v2/Advertisement/Get";

export const CREATE_ADVERTISMENT = "admin/v2/Advertisement/Insert";
export const EDIT_ADVERTISMENT = "admin/v2/Advertisement/Edit";
export const DELETE_ADVERTISMENT = "admin/v2/Advertisement/Delete";
export const EXPORT_ADVERTISMENT = "admin/v2/Advertisement/Export";
export const EDIT_ADVERTISMENT_ACTIVE = "admin/v2/Advertisement/EditActive";

/* AdvertisementData */
export const GET_ALL_ADVERTISMENT_DATA = "admin/v2/AdvertisementData/GetAll";
export const CREATE_ADVERTISMENT_DATA = "admin/v2/AdvertisementData/Insert";
export const EDIT_ADVERTISMENT_DATA = "admin/v2/AdvertisementData/Edit";
export const DELETE_ADVERTISMENT_DATA = "admin/v2/AdvertisementData/Delete";
export const EXPORT_ADVERTISMENT_DATA = "admin/v2/AdvertisementData/Export";
export const EDIT_STATE_ADVERTISMENT_DATA = "admin/v2/Advertisement/EditState";
export const EDIT_STATE_ADVERTISMENT_ACTIVE = "admin/v2/AdvertisementData/EditActive";

/* AdvertisementGallery */
export const GET_ALL_ADVERTISMENT_GALLERY =
  "admin/v2/AdvertisementGallery/GetAll";
export const CREATE_ADVERTISMENT_GALLERY =
  "admin/v2/AdvertisementGallery/Insert";
export const EDIT_ADVERTISMENT_GALLERY = "admin/v2/AdvertisementGallery/Edit";
export const DELETE_ADVERTISMENT_GALLERY =
  "admin/v2/AdvertisementGallery/Delete";
export const EXPORT_ADVERTISMENT_GALLERY =
  "admin/v2/AdvertisementGallery/Export";

/* Booth */
export const GET_ALL_BOOTH = "admin/v2/Booth/GetAll";
export const CREATE_BOOTH = "admin/v2/Booth/Insert";
export const EDIT_BOOTH = "admin/v2/Booth/Edit";
export const DELETE_BOOTH = "admin/v2/Booth/Delete";
export const EXPORT_BOOTH = "admin/v2/Booth/Export";
export const EDIT_BOOTH_ACTIVE = "admin/v2/Booth/EditActive";

/* Category */
export const GET_ALL_CATEGORY = "admin/v2/Category/GetAll";
export const GET_CATEGORY = "admin/v2/Category/Get";

export const CREATE_CATEGORY = "admin/v2/Category/Insert";
export const EDIT_CATEGORY = "admin/v2/Category/Edit";
export const DELETE_CATEGORY = "admin/v2/Category/Delete";
export const EXPORT_CATEGORY = "admin/v2/Category/Export";
export const EDIT_CATEGORY_ACTIVE = "admin/v2/Category/EditActive";

/* CategoryField */
export const GET_ALL_CATEGORY_FEILD = "admin/v2/CategoryField/GetAll";
export const CREATE_CATEGORY_FEILD = "admin/v2/CategoryField/Insert";
export const EDIT_CATEGORY_FEILD = "admin/v2/CategoryField/Edit";
export const DELETE_CATEGORY_FEILD = "admin/v2/CategoryField/Delete";
export const EXPORT_CATEGORY_FEILD = "admin/v2/CategoryField/Export";
export const EDIT_CATEGORY_FEILD_ACTIVE = "admin/v2/CategoryField/EditActive";

/* Chat */
export const GET_ALL_CHAT = "admin/v2/Chat/GetAll";
export const CREATE_CHAT = "admin/v2/Chat/Insert";
export const EDIT_CHAT = "admin/v2/Chat/Edit";
export const DELETE_CHAT = "admin/v2/Chat/Delete";
export const EXPORT_CHAT = "admin/v2/Chat/Export";
export const EDIT_CHAT_ACTIVE = "admin/v2/Chat/EditActive";

/* Conversation */
export const GET_ALL_CONVERSTAION = "admin/v2/Conversation/GetAll";
export const CREATE_CONVERSTAION = "admin/v2/Conversation/Insert";
export const EDIT_CONVERSTAION = "admin/v2/Conversation/Edit";
export const DELETE_CONVERSTAION = "admin/v2/Conversation/Delete";
export const EXPORT_CONVERSTAION = "admin/v2/Conversation/Export";
export const EDIT_CONVERSTAION_ACTIVE = "admin/v2/Conversation/EditActive";

/* Field */
export const GET_ALL_FEILD = "admin/v2/Field/GetAll";
export const CREATE_FEILD = "admin/v2/Field/Insert";
export const EDIT_FEILD = "admin/v2/Field/Edit";
export const DELETE_FEILD = "admin/v2/Field/Delete";
export const EXPORT_FEILD = "admin/v2/Field/Export";
export const EDIT_FEILD_ACTIVE = "admin/v2/Field/EditActive";
export const DELETE_FEILD_IMAGE = "admin/v2/Field/DeleteImage";

/* FieldValue */
export const GET_ALL_FEILD_VALUE = "admin/v2/FieldValue/GetAll";
export const CREATE_FEILD_VALUE = "admin/v2/FieldValue/Insert";
export const EDIT_FEILD_VALUE = "admin/v2/FieldValue/Edit";
export const DELETE_FEILD_VALUE = "admin/v2/FieldValue/Delete";
export const EXPORT_FEILD_VALUE = "admin/v2/FieldValue/Export";
export const EDIT_FEILD_VALUE_ACTIVE = "admin/v2/FieldValue/EditActive";

/* Gallery */
export const GET_ALL_GALLERY = "admin/v2/Gallery/GetAll";
export const CREATE_GALLERY = "admin/v2/Gallery/Insert";
export const EDIT_GALLERY = "admin/v2/Gallery/Edit";
export const DELETE_GALLERY = "admin/v2/Gallery/Delete";
export const EXPORT_GALLERY = "admin/v2/Gallery/Export";

/* LastVisit */
export const GET_ALL_LAST_VISIT = "admin/v2/LastVisit/GetAll";
export const CREATE_LAST_VISIT = "admin/v2/LastVisit/Insert";
export const EDIT_LAST_VISIT = "admin/v2/LastVisit/Edit";
export const DELETE_LAST_VISIT = "admin/v2/LastVisit/Delete";
export const EXPORT_LAST_VISIT = "admin/v2/LastVisit/Export";

/* MainCategoryField */
export const GET_ALL_MAIN_CATEGORY_FEILD = "admin/v2/MainCategoryField/GetAll";
export const CREATE_MAIN_CATEGORY_FEILD = "admin/v2/MainCategoryField/Insert";
export const EDIT_MAIN_CATEGORY_FEILD = "admin/v2/MainCategoryField/Edit";
export const DELETE_MAIN_CATEGORY_FEILD = "admin/v2/MainCategoryField/Delete";
export const EXPORT_MAIN_CATEGORY_FEILD = "admin/v2/MainCategoryField/Export";

/* Slider */
export const GET_ALL_SLIDER = "admin/v2/Slider/GetAll";
export const CREATE_SLIDER = "admin/v2/Slider/Insert";
export const EDIT_SLIDER = "admin/v2/Slider/Edit";
export const DELETE_SLIDER = "admin/v2/Slider/Delete";
export const EXPORT_SLIDER = "admin/v2/Slider/Export";
export const EDIT_SLIDER_ACTVE = "admin/v2/Slider/EditActive";

/* Transaction */
export const GET_ALL_TRANSACTION = "admin/v2/Transaction/GetAll";
export const CREATE_TRANSACTION = "admin/v2/Transaction/Insert";
export const EDIT_TRANSACTION = "admin/v2/Transaction/Edit";
export const DELETE_TRANSACTION = "admin/v2/Transaction/Delete";
export const EXPORT_TRANSACTION = "admin/v2/Transaction/Export";

/* User */
export const GET_ALL_USER = "admin/v2/User/GetAll";
export const SINGLE_USER = "admin/v2/User/Get";
export const PASSWORD_USER = "admin/v2/User/ChangePassword";
export const EDIT_USER_AVATAR = "admin/v2/User/EditAvatar";


/* export const EDIT_USER_ACTIVE = "admin/v2/User/EditActive";
 */
export const CREATE_USER = "admin/v2/User/Insert";
export const EDIT_USER = "admin/v2/User/Edit";
export const DELETE_USER = "admin/v2/User/Delete";
export const EXPORT_USER = "admin/v2/User/Export";
export const EDIT_USER_ACTIVE = "admin/v2/User/EditActive";
/* WishList */
export const GET_ALL_WISH_LIST = "admin/v2/WishList/GetAll";
export const CREATE_WISH_LIST = "admin/v2/WishList/Insert";
export const EDIT_WISH_LIST = "admin/v2/WishList/Edit";
export const DELETE_WISH_LIST = "admin/v2/WishList/Delete";
export const EXPORT_WISH_LIST = "admin/v2/WishList/Export";

/*  ----- address ----- */

/* ----- country ------ */
export const GET_ALL_COUNTRY = "admin/v2/Country/GetAll";
export const CREATE_COUNTRY = "admin/v2/Country/Insert";
export const EDIT_COUNTRY = "admin/v2/Country/Edit";
export const EDIT_COUNTRY_ACTIVE = "admin/v2/Country/EditActive";

export const DELETE_COUNTRY = "admin/v2/Country/Delete";
export const EXPORT_COUNTRY = "admin/v2/Country/Export";

/* ----- Province ------ */
export const GET_ALL_PROVINCE = "admin/v2/Province/GetAll";
export const CREATE_PROVINCE = "admin/v2/Province/Insert";
export const EDIT_PROVINCE = "admin/v2/Province/Edit";
export const DELETE_PROVINCE = "admin/v2/Province/Delete";
export const EXPORT_PROVINCE = "admin/v2/Province/Export";

/* ----- city ------ */
export const GET_ALL_CITY = "admin/v2/City/GetAll";
export const CREATE_CITY = "admin/v2/City/Insert";
export const EDIT_CITY = "admin/v2/City/Edit";
export const DELETE_CITY = "admin/v2/City/Delete";
export const EXPORT_CITY = "admin/v2/City/Export";

/* ----- region ------ */
export const GET_ALL_REGION = "admin/v2/Region/GetAll";
export const CREATE_REGION = "admin/v2/Region/Insert";
export const EDIT_REGION = "admin/v2/Region/Edit";
export const DELETE_REGION = "admin/v2/Region/Delete";
export const EXPORT_REGION = "admin/v2/Region/Export";
export const GET_SETTINGS = "admin/v2/Setting/Get?id=1";
export const EDIT_SETTINGS = "admin/v2/Setting/Edit";
export const EDIT_ACTIVE_SETTINGS = "admin/v2/Setting/EditActive";
export const EDIT_LIGHT_LOGO = "admin/v2/Setting/EditCompanyLogo";
export const EDIT_DARK_LOGO = "admin/v2/Setting/EditCompanyDarkLogo";
export const EDIT_COMPANY_SEAL = "admin/v2/Setting/EditCompanySeal";
// footer logos
export const GET_FOOTER_LOGOS = "admin/v2/FooterLogo/GetAll";
export const EXPORT_FOOTER_LOGOES = "admin/v2/FooterLogo/Export";
export const CREATE_FOOTER_LOGOES = "admin/v2/FooterLogo/Insert";
export const EDIT_FOOTER_LOGOES = "admin/v2/FooterLogo/Edit";
export const DELETE_FOOTER_LOGOES = "admin/v2/FooterLogo/Delete";
export const EDIT_ACTIVE_FOOTER_LOGOES = "admin/v2/FooterLogo/EditActive";
export const GET_SITE_LINK = "admin/v2/SiteLink/GetAll";
export const EXPORT_SITE_LINK = "admin/v2/SiteLink/Export";
export const CREATE_SITE_LINK = "admin/v2/SiteLink/Insert";
export const EDIT_SITE_LINK = "admin/v2/SiteLink/Edit";
export const DELETE_SITE_LINK = "admin/v2/SiteLink/Delete";
export const EDIT_ACTIVE_SITE_LINK = "admin/v2/SiteLink/Edit";
